import { render, staticRenderFns } from "./hot-search.vue?vue&type=template&id=1d304a88&scoped=true&"
import script from "./hot-search.vue?vue&type=script&lang=js&"
export * from "./hot-search.vue?vue&type=script&lang=js&"
import style0 from "./hot-search.vue?vue&type=style&index=0&id=1d304a88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d304a88",
  null
  
)

export default component.exports